export default "__VITE_ASSET__45de9e79__"